import type { ProductsSuggestionSearchResult } from '../../interfaces/algoliaResponse';

export const FETCH_SEARCH_BAR_PRODUCTS =
  'productDiscovery/HeaderLeonidas/FETCH_SEARCH_BAR_PRODUCTS';
export const FETCH_SEARCH_BAR_PRODUCTS_SUCCESS =
  'productDiscovery/HeaderLeonidas/FETCH_SEARCH_BAR_PRODUCTS_SUCCESS';
export const FETCH_SEARCH_BAR_PRODUCTS_FAILED =
  'productDiscovery/HeaderLeonidas/FETCH_SEARCH_BAR_PRODUCTS_FAILED';

export interface FetchSearchBarProducts {
  type: typeof FETCH_SEARCH_BAR_PRODUCTS;
}
export const fetchSearchBarProducts = (): FetchSearchBarProducts => ({
  type: FETCH_SEARCH_BAR_PRODUCTS,
});

export interface FetchSearchBarProductsSuccess {
  type: typeof FETCH_SEARCH_BAR_PRODUCTS_SUCCESS;
  results: ProductsSuggestionSearchResult;
}
export const fetchSearchBarProductsSuccess = (
  results: ProductsSuggestionSearchResult,
): FetchSearchBarProductsSuccess => ({
  type: FETCH_SEARCH_BAR_PRODUCTS_SUCCESS,
  results,
});

export interface FetchSearchBarProductsFailed {
  type: typeof FETCH_SEARCH_BAR_PRODUCTS_FAILED;
}
export const fetchSearchBarProductsFailed =
  (): FetchSearchBarProductsFailed => ({
    type: FETCH_SEARCH_BAR_PRODUCTS_FAILED,
  });

export type Action =
  | FetchSearchBarProducts
  | FetchSearchBarProductsSuccess
  | FetchSearchBarProductsFailed;
